export default "__VITE_ASSET__3994dbf1__"